import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Logger from '../../../../services/Logger';
import { showCreateMasterProductModal } from '../../../../components/ProductsTree/CreateMasterProductModal';
import * as mainActions from '../../../../store/actions/main';

export default function useCreateProduct() {
  const openedTree = useSelector((state) => state.main.openedTree);
  const dispatch = useDispatch();

  const createProduct = useCallback((e) => {
    e.stopPropagation();
    Logger.log('User', 'ProductsPanelAddProduct');
    showCreateMasterProductModal({
      onSuccess: () => {
        if (openedTree !== 'products') {
          dispatch(mainActions.changeTree('products'));
        }
      },
    });
  }, [dispatch, openedTree]);

  return { createProduct };
}
